const fireRetailVisitorIdIsAvailable = () => {
  // trigger event
  const event = new CustomEvent('retail-visitor-id-is-available', {
    detail: {
      googleRetailVisitorId: window.RVN.googleRetailVisitorId,
    },
  });
  window.dispatchEvent(event);
};

const visitorIdFromGA = () => {
  const gaUserId = document.cookie.match(/_ga=GA1\.\d+\.(\d+\.\d+)/)[1];

    window.RVN = {
      ...window.RVN,
      googleRetailVisitorId: gaUserId,
    };
    fireRetailVisitorIdIsAvailable();
}

const visitorIdFromHeartbeat = async () => {
  const heartbeatId = JSON.parse(localStorage?.getItem('exp_hbeat'))?.id;

  if (heartbeatId) {
    window.RVN = {
      ...window.RVN,
      googleRetailVisitorId: heartbeatId.toString(),
    };

    fireRetailVisitorIdIsAvailable();
  }
};

const initSetVisitorIdForGoogleRetail = () => {
  const gaUserId = document.cookie.match(/_ga=GA1\.\d+\.(\d+\.\d+)/)?.[1];

  if (gaUserId) {
    return visitorIdFromGA();
  }
  return visitorIdFromHeartbeat();
}

export default initSetVisitorIdForGoogleRetail;
